import PropTypes from 'prop-types';
import { useManagedContext, useNav } from "../../hooks"
import { MESSAGE_MODALS } from "../../../context/custom/MessageModalContext"
import { useDispatch } from "react-redux"
import { dataTaggerActionClear } from '@laramie/ui';
// TODO: manejar processKey en contexto global
export const FooterButtonVolver = ({ pendingChange, processKey, to, filters, allowNavigation }) => {
    const { isTempView, showMessageModal } = useManagedContext()
    const navigate = useNav()
    const dispatch = useDispatch()

    const onClickSalir = () => {
        const close = () => {
            if (processKey) dispatch(dataTaggerActionClear(processKey))

            allowNavigation?.()
            window.close()
        }

        if (pendingChange) showMessageModal({ ...MESSAGE_MODALS.CONFIRM_SALIR, onConfirm: close })
        else close()
    }

    const onClickVolver = () => {
        const volver = () => {
            if (processKey) dispatch(dataTaggerActionClear(processKey))

            allowNavigation?.()
            const navOptions = { to: to ?? -1 }
            if (filters) {
                navOptions.options = { state: { filters } }
            }

            navigate(navOptions)
        }

        if (pendingChange) showMessageModal({ ...MESSAGE_MODALS.CONFIRM_SALIR, onConfirm: volver })
        else volver()
    }

    return isTempView ? (
        <button className="btn back-button float-start" onClick={onClickSalir}>Volver</button>
    ) : (
        <button className="btn back-button float-start" onClick={onClickVolver}>Volver</button>
    )
}

FooterButtonVolver.propTypes = {
    pendingChange: PropTypes.bool,
    processKey: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    filters: PropTypes.object,
    allowNavigation: PropTypes.func
};